
export const PRIMARY_COLOR = "#0D113A"
export const SECONDARY_COLOR = "#FFD25D"
export const TERTIARY_COLOR = "#e9322b"
export const WARNING_COLOR = "#FFC107"
export const DANGER_COLOR = "#ed1c23"
export const SUCCESS_COLOR = "#4caf50"
export const INFO_COLOR = "#2196f3"
export const LIGHT_PURPLE_COLOR = "#e6d1f2";
